import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators/custom-element.js';

import styles from './rhpt-trial-listing.css';

/**
 * Trial Listing
 * @slot - Place element content here
 */
@customElement('rhpt-trial-listing')
export class RhptTrialListing extends LitElement {
  static readonly styles = [styles];

  async initialize() {
    const children = this.querySelectorAll(':scope > *:not(.rh-band-header--component, rh-dialog)');
    [...children].forEach((el, index) => {
      (el as HTMLElement).style.setProperty('--_count', children.length.toString());
      (el as HTMLElement).style.setProperty('--_index', index.toString());
    });
    this.classList.add('animate');
  }

  render() {
    return html`
      <div part="base">
        <div part="heading">
          <slot name="title" part="title"></slot>
          <slot name="subtitle" part="subtitle"></slot>
          <slot name="description" part="description"></slot>
        </div>
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rhpt-trial-listing': RhptTrialListing;
  }
}
